import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import CandView from '../views/CandidatesView.vue'
import CustView from '../views/CustomersView.vue'
import OppView from '../views/OppView.vue'
import DashboardView from '../views/Dashboard.vue'
import WelcomeView from '../views/Welcome.vue'
import { AuthStore } from '@/stores'
import { AuthServiceInstance } from '@/lynxapi'

const routes = [
  {
    path: '/',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView,
    redirect: { name: 'WelcomeView' },
    meta: { requiresAuth: true },
    children: [
      {
        path: 'welcome',
        name: 'WelcomeView',
        component: WelcomeView,
        meta: { requiresAuth: true }
      },
      {
        path: 'cand',
        name: 'CandidatesView',
        component: CandView,
        meta: { requiresAuth: true }
      },
      {
        path: 'cust',
        name: 'CustomersView',
        component: CustView,
        meta: { requiresAuth: true }
      },
      {
        path: 'opp',
        name: 'OppView',
        component: OppView,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Flag module-level : la restauration ne se fait qu'une fois par chargement de page
let authRestored = false

router.beforeEach(async (to, from, next) => {
  if (!authRestored) {
    authRestored = true
    if (!AuthStore().AuthInfos) {
      try {
        const creds = await AuthServiceInstance.retrieveCredentials()
        if (creds) {
          await AuthServiceInstance.login(creds.login, creds.password)
        }
      } catch {
        // Credentials invalides ou serveur indisponible → l'utilisateur ira au login
      }
    }
  }

  if (to.matched.some(r => r.meta.requiresAuth)) {
    if (AuthStore().AuthInfos) {
      next()
    } else {
      next({ name: 'LoginView' })
    }
  } else {
    next()
  }
})

export default router
